import { ErrorBoundary } from 'components/common/error-boundary';
import { HitterLibrary } from 'components/sections/hitter-library';
import { HitterProfile } from 'components/sections/hitter-library/profile';
import { HPHitterSession } from 'components/sections/hitter-library/profile/reports/hitter-session';
import { HPHitterSessionNew } from 'components/sections/hitter-library/profile/reports/hitter-session-new';
import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { Navigate, Route, Routes } from 'react-router-dom';
import { paths, routePaths } from 'routes/paths';

const RedirectToIndex = () => (
  <Navigate to={paths.hitterLibrary.hitters} replace />
);

export const HitterLibraryRouter = () => {
  const showNewHitterSession = useFeatureFlag('analytics-2');

  return (
    <ErrorBoundary identifier="HitterLibraryRouter">
      <Routes>
        <Route path="" element={<RedirectToIndex />} />
        <Route
          path={routePaths.hitterLibrary.hitters}
          element={<HitterLibrary />}
        />
        <Route
          path={routePaths.hitterLibrary.profile}
          element={<HitterProfile identifier="HitterProfile" verbose />}
        />
        <Route
          path={routePaths.hitterLibrary.session}
          element={
            showNewHitterSession ? (
              <HPHitterSessionNew identifier="HLHitterSessionNew" />
            ) : (
              <HPHitterSession identifier="HLHitterSession" />
            )
          }
        />
        <Route path="*" element={<RedirectToIndex />} />
      </Routes>
    </ErrorBoundary>
  );
};
